webpackJsonp([55702396619907],{

/***/ 419:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"alexk.io"}},"allMarkdownRemark":{"group":[{"fieldValue":"flights","totalCount":1},{"fieldValue":"travel","totalCount":1}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-d265c9fef9e4b93adb6a.js